import { render, staticRenderFns } from "./DemonstrationPage.vue?vue&type=template&id=5226f684"
import script from "./DemonstrationPage.vue?vue&type=script&lang=js"
export * from "./DemonstrationPage.vue?vue&type=script&lang=js"
import style0 from "./DemonstrationPage.vue?vue&type=style&index=0&id=5226f684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports